/**
 * Value Props Section Component
 * Figma: ValueProps (Node: 479:19794)
 *
 * Shows key value propositions: Smart Search and Brand Discovery
 * Dimensions: 1280px wide, 435.125px tall
 */
"use client";

import { colors } from "@/styles/design-tokens";

export function ValuePropsSection() {
  return (
    <section
      className="flex w-full justify-center"
      style={{
        borderTop: `1px solid ${colors.divider.light}`,
        borderBottom: `1px solid ${colors.divider.light}`,
      }}
    >
      <div
        className="flex w-full flex-col items-center px-4 sm:px-8"
        style={{
          maxWidth: "1280px",
          width: "100%",
          paddingTop: "clamp(40px, 6vw, 64px)",
          paddingBottom: "clamp(40px, 6vw, 64px)",
          gap: "32px",
        }}
      >
        <div className="w-full max-w-[720px]">
          <p className="text-body-lg text-ink text-center">
            Find clothing with intelligence at your fingertips. Search, browse, or ask a question.
            Try it all.
          </p>
        </div>

        <div
          className="grid w-full max-w-[720px] gap-10 sm:grid-cols-2"
          style={{
            paddingTop: "4px",
          }}
        >
          <ValuePropCard
            label="Smart Search"
            description="Ask in-depth questions or search directly"
          />
          <ValuePropCard
            label="Brand Discovery"
            description="Find designers and collections that are you-aligned"
          />
        </div>
      </div>
    </section>
  );
}

function ValuePropCard({ label, description }: { label: string; description: string }) {
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <p
        style={{
          fontSize: "10px",
          fontFamily: "Inter, sans-serif",
          fontWeight: 400,
          lineHeight: "15px",
          letterSpacing: "0.9172px",
          textTransform: "uppercase",
          color: "rgba(0, 0, 0, 0.4)",
        }}
      >
        {label}
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Inter, sans-serif",
          fontWeight: 400,
          lineHeight: "21.125px",
          letterSpacing: "-0.4012px",
          color: colors.text.black,
        }}
      >
        {description}
      </p>
    </div>
  );
}
